(() => {
  // app/scripts/product-select-addons-popup.js
  var customElementsName = "addon-component";
  if (!window.customElements.get(customElementsName)) {
    class AddOnComponent extends HTMLElement {
      constructor() {
        super();
        this.settings = {
          config: {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            }
          }
        };
        this.attachEvent();
      }
      attachEvent() {
        this.addEventListener("change", (e) => {
          const input = e.target.closest("input.js-add-on") ? e.target : e.target.closest("li").querySelector("input.js-add-on");
          if (!input) return;
          if (this.timeout != null) clearTimeout(this.timeout);
          input.classList.add("addOn-loading");
          this.timeout = setTimeout(() => {
            this.addOnHandle(input);
            this.timeout = null;
          }, 700);
        });
        this.attachEventSize();
      }
      attachEventSize() {
        const sizeToggles = this.querySelectorAll(".js-addon-select-size");
        sizeToggles.forEach((toggle) => {
          toggle.addEventListener("click", (e) => {
          });
        });
      }
      addOnHandle(input) {
        let isChecked = input.checked;
        let item = {
          id: input.value
        };
        isChecked ? this.add(item, input) : this.change(item, input);
      }
      async add(item, currentInput) {
        const formData = new FormData();
        formData.append("id", item.id);
        formData.append("quantity", 1);
        formData.append("sections", currentInput.dataset.section);
        formData.append("sections_url", currentInput.dataset.url);
        if (currentInput.dataset.properties) {
          const addOnForProperty = currentInput.dataset.properties.split(":");
          formData.append(`properties[${addOnForProperty[0].trim()}]`, addOnForProperty[1].trim());
        }
        const div = currentInput.parentElement.querySelector(".js-addon-properties");
        if (div.querySelectorAll("input").length > 0) {
          const defaultProps = [...div.querySelectorAll("input")].map((input) => {
            return {
              [input.name]: input.value
            };
          });
          for (let index = 0; index < defaultProps.length; index++) {
            const obj = defaultProps[index];
            const [[key, value]] = Object.entries(obj);
            formData.append(key, value);
          }
        }
        if (window.bcpo && window.bcpo.$) {
          const sentBy = "theme";
          window.bcpo.$(document).triggerHandler("bcpo:beforeAddToCart", [formData, sentBy]);
        }
        const isInCart = this.closest("cart-component");
        if (isInCart) {
          isInCart.style.pointerEvents = "none";
          window.addEventListener(
            "cart:ready",
            (evt) => {
              isInCart.style.pointerEvents = "auto";
            },
            { once: true }
          );
        } else {
          const addOnsDrawer2 = document.querySelector("#addOnsDrawer");
          const viewCartButton = addOnsDrawer2.querySelector(".jsAddOnsClose");
          const checkoutButton = addOnsDrawer2.querySelector('.cart-notify [name="checkout"]');
          if (viewCartButton) viewCartButton.style.pointerEvents = "none";
          if (checkoutButton) checkoutButton.style.pointerEvents = "none";
          window.addEventListener(
            "cart:ready",
            (evt) => {
              if (viewCartButton) viewCartButton.style.pointerEvents = "auto";
              if (checkoutButton) checkoutButton.style.pointerEvents = "auto";
            },
            { once: true }
          );
        }
        try {
          const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            body: formData
          });
          if (!response.ok) {
            throw new Error("Something wrongs");
          }
          const resp = await response.json();
          let itemOnCart = resp;
          currentInput.setAttribute("data-quantity", itemOnCart.quantity);
          const div2 = document.createElement("div");
          if (resp.sections && resp.sections[currentInput.dataset.section]) {
            div2.innerHTML = resp.sections[currentInput.dataset.section];
            const newInput = [...div2.querySelectorAll("input.js-add-on")].find((input) => input.id = currentInput.id);
            if (newInput) currentInput.value = newInput.value;
          }
          document.dispatchEvent(new CustomEvent("cart:build"));
          currentInput.classList.remove("addOn-loading");
        } catch (error) {
          console.log("addons popup error::", error);
          currentInput.classList.remove("addOn-loading");
          currentInput.checked = false;
        }
      }
      change(item, currentInput) {
        let config = this.settings.config;
        let qty = 0;
        config.body = JSON.stringify({
          id: item.id,
          quantity: qty,
          sections: [currentInput.dataset.section],
          sections_url: currentInput.dataset.url
        });
        const isInCart = this.closest("cart-component");
        if (isInCart) {
          isInCart.style.pointerEvents = "none";
          window.addEventListener(
            "cart:ready",
            (evt) => {
              isInCart.style.pointerEvents = "auto";
            },
            { once: true }
          );
        }
        fetch(window.Shopify.routes.root + "cart/change.js", config).then((resp) => resp.json()).then((resp) => {
          if (resp.item_count) {
            let itemOnCart = resp.items.filter((i) => i.id == item.id);
            if (itemOnCart.length) {
              currentInput.setAttribute("data-quantity", itemOnCart[0].quantity);
              currentInput.checked = true;
              return;
            }
          }
          const div = document.createElement("div");
          if (resp.sections && resp.sections[currentInput.dataset.section]) {
            div.innerHTML = resp.sections[currentInput.dataset.section];
            const newInput = div.querySelector("#" + currentInput.id);
            if (newInput) currentInput.value = newInput.value;
          }
          currentInput.setAttribute("data-quantity", 0);
          [...document.querySelectorAll(`input[name="${currentInput.name}"][data-item-id="${currentInput.dataset.itemId}"]`)].forEach((i) => {
            i.checked = false;
          });
          document.dispatchEvent(new CustomEvent("cart:build"));
        }).catch((error) => console.log(error)).finally(() => {
          currentInput.classList.remove("addOn-loading");
        });
      }
      static onRefresh(event) {
        const {
          detail: { cart }
        } = event;
        const { items } = cart;
        console.log("onRefresh::", items);
        const cartItems = items.map((item) => item.variant_id.toString());
        [...document.querySelectorAll("addon-component .js-add-on[data-item-id]")].forEach((item, index) => {
          item.checked = cartItems.includes(item.dataset.itemId);
        });
      }
      static handleOpen(e) {
        const addClass = e?.detail?.addClass;
        const addOnsDrawer2 = document.querySelector("#addOnsDrawer");
        if (!addOnsDrawer2) return;
        if (addClass) {
          console.log("window.tempCompleteTheLook::", window.tempCompleteTheLook);
          if (window.tempCompleteTheLook) {
            window.tempCompleteTheLook.forEach((item) => {
              console.log("item::", item);
              const matchItem = addOnsDrawer2.querySelector(`.added-to-cart-item[data-product-id="${item}"]`);
              if (!matchItem) return;
              matchItem.classList.remove("hidden");
            });
            window.tempCompleteTheLook = null;
          }
          const mainPriceEl = document.querySelector("product-container .js-main-price");
          const originPriceEl = addOnsDrawer2.querySelector(".js-atc-main-item price-component");
          originPriceEl?.set(mainPriceEl.getAttribute("data-value"));
          AddOnComponent.addAddonsTransition();
        } else {
          addOnsDrawer2.classList.remove("show-cart-noti");
          addOnsDrawer2.classList.remove("addons-transition");
        }
        addOnsDrawer2.open();
      }
      static handleClose(e) {
        const { target } = e;
        if (target.closest(".jsAddOnsClose")) {
          e.preventDefault();
          const addOnsDrawer2 = document.querySelector("#addOnsDrawer");
          addOnsDrawer2.close();
          setTimeout(() => {
            window.dispatchEvent(new Event("drawer:open-cart"));
          }, 600);
        }
        if (target.closest(".launch-bold-metrics.js-drawer-close")) {
          e.preventDefault();
          const addOnsDrawer2 = document.querySelector("#addOnsDrawer");
          addOnsDrawer2.close();
        }
      }
      static afterPopupCloseHandler(e) {
        const id = e.detail.id;
        if (!id || id != "addOnsDrawer") return;
        const addOnsDrawer2 = document.querySelector("#addOnsDrawer");
        if (!addOnsDrawer2) return;
        addOnsDrawer2.classList.remove("show-cart-noti");
        addOnsDrawer2.classList.remove("addons-transition");
        addOnsDrawer2.querySelectorAll(".added-to-cart-item:not(.js-atc-main-item)").forEach((item) => {
          item.classList.add("hidden");
        });
      }
      static bindWindowEvents() {
        window.addEventListener("addOn:refresh", AddOnComponent.onRefresh);
        if (theme.routes.pageType == "product") {
          document.body.addEventListener("click", AddOnComponent.handleClose);
          window.addEventListener("addOn:open", AddOnComponent.handleOpen);
          document.addEventListener("popup:afterClose", AddOnComponent.afterPopupCloseHandler);
        }
      }
      static addAddonsTransition() {
        const hasFitProfile = document.body.classList.contains("measurement-profile-loaded");
        console.log("document.body.classList::", document.body.classList);
        if (!hasFitProfile) {
          setTimeout(() => {
            addOnsDrawer.classList.add("addons-transition");
          }, 300);
        }
      }
    }
    AddOnComponent.bindWindowEvents();
    window.customElements.define(customElementsName, AddOnComponent);
  }
})();
